<template>
  <div id="app">
    <router-view :key="key"/>
    <div class="loader-box" v-if="pulseLoader">
      <pulse-loader :loading="pulseLoader"></pulse-loader>
    </div>
    <!-- watch中监听页面的路由变化,将不需要问题帮助的页面筛选出来 -->
    <div class="see-help" v-show="showHelp">
      <el-link href="https://labfmaster.baklib-free.com/" type="danger" target="_blank"
               style="text-align:center;color:#44A8F3">
        <icon name="FAQ" :w="40" :h="40"></icon>
        <p>问题帮助</p>
      </el-link>
    </div>
    <!-- 页面扫码注册,登录后不可见 -->
    <div class="register" v-if="registerShow">
      <div>
        <p>
          <i class="el-icon-close" @click="registerShow=false"></i>
        </p>
        <img src="~@/assets/imgs/WeChat_accounts-fmaster.png" alt="丰迈信息">
        <img src="~@/assets/imgs/WeChat_1.png" alt="平台使用反馈群">
      </div>
    </div>

    <update-mobile :visible.sync="dialogVisible" :close-on-press-escape="false" :show-close="false" :show-alert="true"
                   :form-data="{
          id: userInfo.id,
          mobile: userInfo.mobile
        }"/>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import {verify} from '@/api/auth/jwt'
import updateMobile from '@/views/user/components/update-mobile'

export default {
  name: "app",
  data() {
    return {
      // 是否显示注册二维码
      registerShow: true,
      // 是否显示问题帮助
      showHelp: true,
      // 绑定手机号提示框
      dialogVisible: false
    }
  },
  components: {
    PulseLoader,
    updateMobile
  },
  methods: {
    ...mapActions(['setCurrentExpInfo', 'GetUserInfo']),
    verifyDet() {
      verify().then(() => {
      }).catch(() => {
      })
    },
    checkBindPhone() {
      if (this.$route.name === 'profile') {
        return
      }
      // 检测是否绑定了手机号
      const {mobile} = this.userInfo
      // 未绑定,提示绑定
      if (mobile == null || mobile === '') {
        this.dialogVisible = true
      }
    }
  },
  watch: {
    "token": {
      // deep: true,
      immediate: true,
      handler: function (newVal) {
        if (!newVal) {
          if (this.setTimer) {
            clearInterval(this.setTimer)
          }
        } else {
          this.setTimer = setInterval(this.verifyDet, 30000)
        }
      }
    },
    userInfo: {
      deep: true,
      immediate: true,
      handler: function (newVal) {
        if (this.isLogin && (newVal.mobile == null || newVal.mobile === '')) {
          this.checkBindPhone()
        } else {
          this.dialogVisible = false
        }
      }
    },
    '$route': {
      immediate: true,
      handler: function (route) {
        const {name} = route;
        const { username } = this.userInfo;
        // 不需要灰度配送的页面
        // let routes = ['lessonExpStart', 'lessonExpMarking']
        // if (routes.indexOf(name) !== -1)
        //     document.getElementsByTagName('body')[0].classList.add("no-filter")
        // else
        //     document.getElementsByTagName('body')[0].classList.remove("no-filter")
        // 二维码改成常显，即使登录也不消失
        // this.registerShow = ["lessons", "fmRegister", "resetPassword"].indexOf(name) < 0 && !username;
        this.registerShow = ["fmRegister", "resetPassword", "lessonExpLineup"].indexOf(name) < 0 && !username;
        this.showHelp = ["fmRegister", "resetPassword", "lessonExpStart", "lessonExpLineup"].indexOf(name) < 0;
        // this.showHelp = ["fmRegister", "resetPassword"].indexOf(name) < 0;
      }
    },
    isLogin(val) {
        if (val) {
            this.registerShow = false
        }
    },
  },
  computed: {
    ...mapGetters(['pulseLoader', 'curExpInfo', 'token', 'userInfo']),
    ...mapGetters("user", ['isLogin']),
    key() {
      return this.$route.path + Math.random()
    },
    isLogin: function () {
      return this.token != null && this.token !== '';
    },
  },
  created() {
    const {token, userInfo} = this
    const {roles} = userInfo
    if (token && !roles) {
      this.GetUserInfo()
    }
    if (this.isLogin) {
      this.checkBindPhone()
    }
  }
}
</script>

<style lang="scss">
.loader-box {
  .v-spinner {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

#app {
  overflow: auto;
}
</style>

<style lang="scss" scoped>
.register {
  position: fixed;
  bottom: 160px;
  right: 40px;
  background-color: #fff;
  z-index: 9999;

  p {
    i {
      line-height: 10px;
      float: right;
      padding: 8px 4px 0 0;
    }
  }

  img {
    width: 140px;
    display: block;
  }
}

.see-help {
  position: fixed;
  bottom: 80px;
  right: 80px;
  z-index: 9999;
}

.loader-box {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999999;
}

.exp-active-box {
  width: 290px;
  height: 165px;
  position: fixed;
  right: 40px;
  bottom: 40px;
  color: #eee;
  background-image: url("~@/assets/imgs/b199d69.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;

  &:hover {
    .EAB-default {
      display: none;
    }

    .EAB-hover {
      display: block;
    }
  }

  .EAB-default {
    .EAB-header {
      height: 34px;
      line-height: 34px;
      padding: 0 5px;
      overflow: hidden;
      background-color: black;

      > * {
        display: inline-block;
        vertical-align: middle;
      }

      .EAB-icon {
        height: 21px;
        font-size: 0;
        line-height: 1em;

        > span {
          width: 3px;
          display: inline-block;
          vertical-align: top;
          margin-left: 2px;
          margin-right: 2px;
          background-color: #14b41e;

          &:nth-child(2n + 1) {
            animation: EABIcon1 0.8s;
            animation-iteration-count: infinite;
          }

          &:nth-child(2n) {
            animation: EABIcon2 0.8s;
            animation-iteration-count: infinite;
          }
        }
      }

      .EAB-title {
        font-size: 16px;
        font-weight: normal;
        padding-left: 0.75em;
        padding-right: 0.75em;
      }
    }

    .EAB-body {
      height: calc(165px - 34px);
      position: relative;

      > * {
        width: 86%;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  .EAB-hover {
    display: none;
    text-align: center;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    > p:not(:first-child) {
      margin-top: 24px;
    }
  }
}
</style>
